import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_CONNECTED_ACCOUNTS = createAsyncActionTypes('FETCH_CONNECTED_ACCOUNTS');